var _defs, _path, _path2, _path3, _path4, _path5, _path6, _line, _path7, _path8;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInterventionalNeuroradiology = function SvgInterventionalNeuroradiology(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Monique",
    viewBox: "0 0 108 108",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".inne{fill:none;stroke:#f9f9fa;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "inne",
    d: "M58.43,43.53A5,5,0,0,0,50.1,48.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "inne",
    d: "M43.14,50.55a6.72,6.72,0,0,0-11.71,4.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "inne",
    d: "M32.78,86V73.42a8.82,8.82,0,0,0-2.3-5.81A26.47,26.47,0,1,1,76.82,50.14c0,.55,0,1.11-.06,1.65a4.55,4.55,0,0,0,.43,2.3l6.06,12.25a2.08,2.08,0,0,1-1.43,3L78,70.14A2.15,2.15,0,0,0,76.36,72l-.88,8.89A5.64,5.64,0,0,1,69.86,86H58.55a8.22,8.22,0,0,1-8.21-8.21V76.62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "inne",
    d: "M42,65.6a3.83,3.83,0,0,0-3.83-3.83"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "inne",
    d: "M38.15,61.77a6.71,6.71,0,0,1-2.41-13A8,8,0,1,1,46.55,37a7.7,7.7,0,0,1,15.24,1.52,6.82,6.82,0,0,1-.1.92,6.84,6.84,0,0,1,1.37-.14,6.63,6.63,0,0,1,1,13.18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "inne",
    d: "M46.73,40.73a7.88,7.88,0,0,1-.33-2.24,7.7,7.7,0,0,1,7.69-7.69"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "inne",
    x1: 41.98,
    y1: 65.6,
    x2: 41.98,
    y2: 76.38
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "inne",
    d: "M53.29,55.92a5.69,5.69,0,1,0,8.34-7.14"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "inne",
    d: "M41.16,55.91a7.28,7.28,0,0,0,13.35-4"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInterventionalNeuroradiology, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/interventional_neuroradiology.0809e136.svg";
export { ForwardRef as ReactComponent };